import React, { PureComponent } from 'react'
import { RESPONSE_PENDING } from '../constants/responses'
import { cache } from '../services/CMSService'

export default ({ request: fnFetchData, cacheKey, cacheTtl }) => WrappedComponent => {
  if (!fnFetchData) throw new Error("[Prismic UniversalComponent] Missing parameter 'request' - must be an async call returning a Promise.")
  if (!WrappedComponent) throw new Error("[Prismic UniversalComponent] Missing parameter 'component' - must be a valid React Component")

  return class extends PureComponent {
    constructor (props) {
      super(props)
      if (!props.cmsCtx) throw new Error(`[Prismic - Component '${WrappedComponent.name}'] You must provide a props 'cmsCtx' which contains at least the object 'api' and the api endpoint.`)
      if (!props.cmsCtx.api) throw new Error(`[Prismic - Component '${WrappedComponent.name}'] You must provide a props 'cmsCtx' which contains at least the object 'api' and the api endpoint.`)
      if (!props.cmsCtx.endpoint) throw new Error(`[Prismic - Component '${WrappedComponent.name}'] You must provide a props 'cmsCtx' which contains at least the object 'api' and the api endpoint.`)
      this.state = { CMS_DATA: RESPONSE_PENDING }
      this.fetchedCacheKey = null
    }

    fetchCmsData () {
      this.fetchedCacheKey = cacheKey
      cache({ request: fnFetchData, ctx: this.props.cmsCtx, props: this.props, cacheKey, cacheTtl })
        .subscribe(CMS_DATA => {
          this.setState({ CMS_DATA })
        })
    }

    componentDidMount () {
      this.fetchCmsData()
    }

    componentDidUpdate () {
      // Only re-fetch when the cache key has actually changed - otherwise a
      // never-cache (cacheTtl: 0) request would re-fetch on every update
      // triggered by its own setState, looping forever.
      if (this.fetchedCacheKey !== cacheKey) {
        this.fetchCmsData()
      }
    }

    render () {
      const newProps = { ...this.props, CMS_DATA: this.state.CMS_DATA }
      return <WrappedComponent {...newProps} />
    }
  }
}
